import request from '@/utils/request'

const userApi = {
    Login: '/auth/login',
    Logout: '/auth/logout',
    UserInfo: '/user/info',
    DeleteImageFile: '/image/delete',
    GetAccountList: '/account/list',
    GetAccountInfo: '/account/get/info',
    CreateAccount: '/account/create',
    ModifyAccount: '/account/edit',
    SetAccountPWD: '/account/update/pwd',
    DeleteAccounts: '/account/delete',
}

export function login(parameter) {
    return request({
        url: userApi.Login,
        method: 'post',
        data: parameter
    })
}

export function DeleteImageFile(parameter) {
    return request({
        url: userApi.DeleteImageFile,
        method: 'post',
        data: parameter
    })
}

export function getInfo() {
    return request({
        url: userApi.UserInfo,
        method: 'get',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    })
}

export function logout() {
    return request({
        url: userApi.Logout,
        method: 'get',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    })
}

export function GetAccountList(parameter) {
    return request({
        url: userApi.GetAccountList,
        method: 'post',
        data: parameter
    })
}

export function GetAccountInfo(parameter) {
    return request({
        url: userApi.GetAccountInfo,
        method: 'get',
        params: parameter
    })
}

export function CreateAccount(parameter) {
    return request({
        url: userApi.CreateAccount,
        method: 'post',
        data: parameter
    })
}

export function ModifyAccount(parameter) {
    return request({
        url: userApi.ModifyAccount,
        method: 'post',
        data: parameter
    })
}

export function SetAccountPWD(parameter) {
    return request({
        url: userApi.SetAccountPWD,
        method: 'post',
        data: parameter
    })
}

export function DeleteAccounts(parameter) {
    return request({
        url: userApi.DeleteAccounts,
        method: 'post',
        data: parameter
    })
}